import React             from 'react';
import { ErrorWindow }   from './ErrorWindow';
import { SuccessWindow } from './SuccessWindow';

export function ModalContent(props: {success: boolean, onClose?: () => void}) {
    return props.success ? <SuccessWindow /> : <ErrorWindow onClose={ props.onClose ? props.onClose : () => {} } />;
}
